import { Map } from 'immutable';
import _ from 'lodash';
import {
  TICKET_MMRM_MODULE_NAMES,
  MEMBER_TICKET_MMRM_MODULE_NAMES,
  MEMBER_CARD_MMRM_MODULE_NAMES,
  POINT_MMRM_MODULE_NAMES,
  LEVEL_MMRM_MODULE_NAMES,
} from '../customApp/constants';
import { createIntl, createIntlCache } from '@formatjs/intl';
import ZhTWlang from '../languageProvider/locales/zh-Hant.json';

const cache = createIntlCache();
export const intl = createIntl(
  {
    locale: 'zh-TW',
    messages: ZhTWlang,
  },
  cache,
);

export function clearToken() {
  sessionStorage.removeItem('api_token');
}

export function getToken() {
  try {
    const apiToken = sessionStorage.getItem('api_token');
    return new Map({ apiToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = number => (number > 1 ? 's' : '');
  const number = num => (num > 9 ? `${num}` : `0${num}`);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return `${days} day${numberEnding(days)}`;
      }
      const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
      ];
      const month = months[givenTime.getUTCMonth()];
      const day = number(givenTime.getUTCDate());
      return `${day} ${month}`;
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  }
  if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

export function truncateStr(str, n) {
  return str.length > n ? `${str.substr(0, n - 1)}...` : str;
}

export function filterSelectOptionsByValue(sourceOptions, blackListStr) {
  const typeOptionBlackListArray = blackListStr.split(',');

  return _.filter(
    sourceOptions,
    option => !~typeOptionBlackListArray.indexOf(option.value.toString()),
  );
}

export function getModuleName(type, code) {
  const typeMapping = {
    ticket: TICKET_MMRM_MODULE_NAMES,
    member_ticket: MEMBER_TICKET_MMRM_MODULE_NAMES,
    member_card: MEMBER_CARD_MMRM_MODULE_NAMES,
    point: POINT_MMRM_MODULE_NAMES,
    level: LEVEL_MMRM_MODULE_NAMES,
  };
  const constantsData = typeMapping[type];
  const moduleNameList = [
    ...constantsData.map(m => ({
      localeName: m.get('name'),
      code: m.get('code'),
    })),
  ];

  const moduleName = moduleNameList.find(data => data.code === code);

  if (typeof moduleName !== 'undefined') {
    return moduleName.localeName;
  }

  return code;
}
